import { render, staticRenderFns } from "./shift-kanban.vue?vue&type=template&id=44f60b83&scoped=true&lang=pug"
import script from "./shift-kanban.vue?vue&type=script&lang=ts"
export * from "./shift-kanban.vue?vue&type=script&lang=ts"
import style0 from "./shift-kanban.vue?vue&type=style&index=0&id=44f60b83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f60b83",
  null
  
)

export default component.exports